import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * [공통] 파일 상세 Entity
 */
export default abstract class TbComFileDetailEntity extends MainEntity {
  @observable protected fileDetailId?: string;
  @observable protected filePolicy?: string;
  @observable protected fileRpstr?: string;
  @observable protected strePath?: string;
  @observable protected streFileNm?: string;
  @observable protected orginlFileNm?: string;
  @observable protected fileExtsn?: string;
  @observable protected fileSize?: number;
  @observable protected registDt?: Date;
  @observable protected registPsnId?: string;
  @observable protected fileGb?: string;

  public getFileDetailId() {
    return this.fileDetailId;
  }

  @action
  public setFileDetailId(fileDetailId: string){
    this.fileDetailId = fileDetailId;
  }

  public getFilePolicy() {
    return this.filePolicy;
  }

  @action
  public setFilePolicy(filePolicy: string) {
    this.filePolicy = filePolicy;
  }

  public getFileRpstr() {
    return this.fileRpstr;
  }

  @action
  public setFileRpstr(fileRpstr: string) {
    this.fileRpstr = fileRpstr;
  }

  public getStrePath() {
    return this.strePath;
  }

  @action
  public setStrePath(strePath: string) {
    this.strePath = strePath;
  }

  public getStreFileNm() {
    return this.streFileNm;
  }

  @action
  public setStreFileNm(streFileNm: string) {
    this.streFileNm = streFileNm;
  }

  public getOrginlFileNm() {
    return this.orginlFileNm;
  }

  @action
  public setOrginlFileNm(orginlFileNm: string) {
    this.orginlFileNm = orginlFileNm;
  }

  public getFileExtsn() {
    return this.fileExtsn;
  }

  @action
  public setFileExtsn(fileExtsn: string) {
    this.fileExtsn = fileExtsn;
  }

  public getFileSize() {
    return this.fileSize;
  }

  @action
  public setFileSize(fileSize: number) {
    this.fileSize = fileSize;
  }

  public getRegistDt() {
    return this.registDt;
  }

  @action
  public setRegistDt(registDt: Date) {
    this.registDt = registDt;
  }

  public getRegistPsnId() {
    return this.registPsnId;
  }

  @action
  public setRegistPsnId(fileGb: string) {
    return this.registPsnId;
  }

  public getFileGb() {
    return this.fileGb
  }

  @action
  public setFileGb(fileGb: string) {
    this.fileGb = fileGb;
  }
}
